<template>
  <InteractionStep :title="$tInteraction('What data is required from the applicant') + '?'"
                   :disabled-next="false"
                   :pending-next="pendingSave"
                   @next="onSave">

    <template v-slot:content>
      <div class="step-text">
        <div class="step-text__text text">
          <p>{{$tInteraction('What data is required text')}}</p>
        </div>
        <div class="step-text__options  button-checkboxes _cols-3">
          <div class="button-checkboxes__list">
            <div class="button-checkboxes__item-col"
                 v-for="(input, key) in inputs"
                 :key="key">
              <label class="checkbox">
                <input type="checkbox"
                       name="type-option"
                       :value="1"
                       v-model="input.value"
                       hidden>
                <span class="checkbox__mark">
                  <BaseSvg name="ico-check"/>
                </span>
                <span class="checkbox__text">
                  {{input.name}}
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <BaseAlert :value="error" class="step-information__error  _error"/>
      <BaseAlert :value="message" class="step-information__error  _warning"/>
    </template>
  </InteractionStep>
</template>

<script>
  import {http} from '@/axios'
  import {
    EMPLOYMENT_TYPE_WORK_VISA,
    EMPLOYMENT_TYPE_SEASON_VISA,
  } from '@/constants/interaction'
  import InteractionStep from '../InteractionStep'
  import interactionStepMixin from "@/mixins/interactionStepMixin"

  export default {
    mixins: [interactionStepMixin],
    data() {
      return {
        pendingSave: false,
        error: null,
        value: null,
        message: null,
        inputs: {
          documents_delivery_address: {
            name: this.$tInteraction('Mail delivery address'),
            value: true
          },
          shoe_size: {
            name: this.$tInteraction('Shoe size'),
            value: false
          },
          clothing_size: {
            name: this.$tInteraction('Clothing size'),
            value: false
          },
          height: {
            name: this.$tInteraction('Growth'),
            value: false
          },
          weight: {
            name: this.$tInteraction('Weight'),
            value: false
          },
          // statement: {
          //   name: this.$tInteraction('Statement'),
          //   value: false
          // },
          visa_data: {
            name: this.$tInteraction('Visa information'),
            value: false
          },
          // nova_poshta: {
          //   name: this.$tInteraction('Nova Poshta'),
          //   value: false
          // },
        }
      }
    },
    components: {
      InteractionStep
    },
    methods: {
      onSave() {
        this.error = null
        this.message = null
        this.pendingSave = true

        const step = this.$store.state.interaction.step
        const sendData = {}

        const inputs = this.inputs
        for (const key in inputs) {
          sendData[key] = inputs[key].value
        }

        sendData.waist = !!sendData.clothing_size

        http.post(`/api/new-interaction/${this.$route.params.id}/${step}`, sendData).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction')
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false
        })
      },
    },
    created() {
      const type = this.$store.state.interaction.data.type_of_employment

      if(
        type === EMPLOYMENT_TYPE_WORK_VISA
        || type === EMPLOYMENT_TYPE_SEASON_VISA
        ) {
       this.inputs.visa_data.value = true
       // this.inputs.statement.value = true
      }
    }
  }
</script>

<style>

</style>
